/** Geographic primitives shared by the web app and the proxy. */

/** [west, south, east, north] in WGS84 degrees. */
export type BBox = readonly [number, number, number, number];

export interface LngLat {
  readonly lng: number;
  readonly lat: number;
}

/**
 * Oklahoma's full extent, used as the default map view and as the bounding box
 * for the pre-demo cache warm. Derived from the WFS capabilities envelope.
 */
export const OKLAHOMA_BBOX: BBox = [-103.0026, 33.6157, -94.4307, 37.0023];

export const OKLAHOMA_CENTER: LngLat = { lng: -97.5, lat: 35.5 };

/** Web Mercator, the projection the map view and the tile grid both use. */
export const WEB_MERCATOR = 'EPSG:3857' as const;
export const WGS84 = 'EPSG:4326' as const;
